import { render, staticRenderFns } from "./BonusModal.vue?vue&type=template&id=13a73682&scoped=true&"
import script from "./BonusModal.vue?vue&type=script&lang=js&"
export * from "./BonusModal.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/accountmove.css?vue&type=style&index=0&id=13a73682&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a73682",
  null
  
)

export default component.exports